import React from "react";

const WidgetLoadingSkeleton = () => {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center px-6 py-8">
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-6 flex justify-center">
          <div className="h-16 w-16 rounded-lg animate-pulse bg-gray-200 dark:bg-neutral-800" />
        </div>
        <div className="h-8 w-48 mx-auto mb-4 rounded animate-pulse bg-gray-200 dark:bg-neutral-800" />
        <div className="h-4 w-64 mx-auto mb-6 rounded animate-pulse bg-gray-200 dark:bg-neutral-800" />
      </div>
    </div>
  );
};

export default WidgetLoadingSkeleton;
